import { useGetProject } from "~/api/projects/projects";
import { NotFound } from "~/components/NotFound";
import { PageLayout } from "~/components/PageLayout";
import { DocumentsList } from "~/features/case/components/list/DocumentsList";
import { ROUTES, useProjectParams } from "~/helpers";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";

export const CasePage = () => {
  useTrackPageVisit("app/case/visit");
  const { organizationId, caseId } = useProjectParams();
  const { isError: isProjectError } = useGetProject(organizationId, caseId);

  if (isProjectError) {
    return <NotFound backRoute={ROUTES.CASES({ organizationId })} />;
  }

  return (
    <PageLayout>
      <DocumentsList />
    </PageLayout>
  );
};
